import { useSelector } from "react-redux";
import { AppBar, Box, Button, ButtonGroup, Chip, Grid, Modal, Paper, Stack, Toolbar, Tooltip, Typography } from "@mui/material";
import { ConversationInfo } from "../../../redux/conversation/conversationSlice";
import { useEffect } from "react";
import { useAppDispatch } from "../../../app/hooks";
import BadgedAvatar from "../../base/BadgedAvatar";
import { NamedObject } from "../../../redux/object/namedObject";

import { ObjectTarget } from "../../../app/permissions";
import { getOrRetrieveNamedObject, selectObjectCache } from "../../../redux/object/objectCacheSlice";
import { retrieveConversationPartyUsers, RetrieveConversationPartyUsersRequest, selectConversationPartyUsers } from "../../../redux/conversation/conversationPartyUsersSlice";
import CloseIcon from "@mui/icons-material/Close";

export interface ModalPartiesListProps {
    conversation: ConversationInfo;
    close: () => void;
    title: string;
    avatar?: string;
    subtitle?: string;
    subavatar?: string;
}

export const ModalPartiesList = (props: ModalPartiesListProps) => {
    const dispatch = useAppDispatch();
    const objectCache = useSelector(selectObjectCache);
    const conversationPartyUsers = useSelector(selectConversationPartyUsers);

    useEffect(() => {
        for (const party of props.conversation.parties) {
            const request = {
                conversationId: props.conversation.id,
                partyId: party.id,
            } as RetrieveConversationPartyUsersRequest;
            console.log("Retrieving party users for conversation", props.conversation.id, "party", party.id);
            dispatch(retrieveConversationPartyUsers(request));
        }
    }, [props.conversation, conversationPartyUsers]);

    const content = () => {
        const parties = [];
        for (const party of props.conversation.parties) {
            const partyUsers = [];
            for(const user of conversationPartyUsers.partyUsers[party.id]?.list || []) {
                const named = getOrRetrieveNamedObject(dispatch, objectCache, ObjectTarget.USER, user.userId) || NamedObject.unknown();
                partyUsers.push(
                    <Grid key={user.userId}>
                        <Paper sx={{ padding: 1, margin: 0, width: "100%" }} elevation={3}>
                            <Stack direction="row" spacing={1} alignItems="center" 
                                sx={{ width: "100%", padding: 0, borderRadius: 1 }}>
                                <BadgedAvatar
                                    key={user.userId}
                                    title={named.display}
                                    avatar={named.thumbnail}
                                    size="27px"
                                    fontSize='12px'
                                />
                                <Typography variant="caption"
                                    sx={{ width: "140px", textWrap: "nowrap", textOverflow: "ellipsis", overflow: "hidden", textAlign: "left" }}>
                                    {named.display}
                                </Typography>
                            </Stack>
                        </Paper>
                    </Grid>
                );
            }
            const named = getOrRetrieveNamedObject(dispatch, objectCache, party.objectTarget, party.targetId) || NamedObject.unknown();
            parties.push(
                <Paper key={party.id} sx={{ backgroundColor: "#ccc", padding: 1, margin: 1, width: "100%" }} elevation={3}>
                    <Stack direction="column" spacing={1} alignItems="center" sx={{ width: "100%" }}>
                        <Stack direction="row" spacing={1} alignItems="center" 
                            sx={{ width: "100%", backgroundColor: "primary.main", padding: 1, borderRadius: 1 }}>
                            <BadgedAvatar 
                                size="30px"
                                title={named.display} avatar={named.thumbnail}/>
                            <Typography variant="h6" color='primary.contrastText'
                                sx={{ width: "200px", textWrap: "nowrap", textOverflow: "ellipsis", overflow: "hidden", textAlign: "left" }}>
                                {named.display}
                            </Typography>
                        </Stack>
                        <Grid container spacing={1} alignItems="center" sx={{ width: "100%" }}>
                            {partyUsers.length > 0 && partyUsers}
                            {partyUsers.length == 0 && <Chip label="Nenhum participante" />}
                        </Grid>
                    </Stack>
                </Paper>
            );
        }
        return <Stack direction="column" spacing={1} alignItems="center">
            {parties}
        </Stack>;

    };

    const avatarSize = 40;
    const subAvatarSize = 20;
    const modalMargin = 50;
    return <Modal open={true} onClose={() => {props.close();}} 
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Paper sx={{ m: `${modalMargin}px`, width: window.innerWidth, minWidth: "300px"/* , height: window.innerHeight-modalMargin*2 */ }} elevation={3}>
            <AppBar position="static" color={"primary"} sx={{ top: "auto", bottom: 0 }}>
                <Toolbar>
                    <BadgedAvatar
                        title={props.title}
                        avatar={props.avatar}
                        subtitle={props.subtitle}
                        subavatar={props.subavatar}
                        size={`${avatarSize}px`}
                        subsize={`${subAvatarSize}px`}
                    />
                    <Stack direction="column" spacing={0} alignItems="center"
                        sx={{ width: "200px", textWrap: "nowrap", textOverflow: "ellipsis", overflow: "hidden", textAlign: "left" }}>
                        <Typography variant="caption" 
                            sx={{ width: "200px", textWrap: "nowrap", textOverflow: "ellipsis", overflow: "hidden", textAlign: "left" }}>
                            {props.subtitle}
                        </Typography>
                        <Typography variant="h6"
                            sx={{ width: "200px", textWrap: "nowrap", textOverflow: "ellipsis", overflow: "hidden", textAlign: "left" }}>
                            {props.title}
                        </Typography>
                    </Stack>
                    <Box sx={{ flexGrow: 1 }} />
                    <ButtonGroup variant="contained" color="secondary">
                        <Tooltip title="Fechar" >
                            <Button key="close" onClick={(/* event */) => { props.close(); }}><CloseIcon /></Button>
                        </Tooltip>
                    </ButtonGroup>
                </Toolbar>
            </AppBar>
            <Box sx={{ padding: 2, height: window.innerHeight-modalMargin*2 - 80, overflowY: "auto" }}>
                {content()}
            </Box>
        </Paper>
    </Modal>;
};